import { useMemo } from 'react';
import type { BespokeFormSectionProps } from '../bespokeRegistry';
import { BespokeSectionProvider, buildSchemaMap } from '../primitives';
import { computeLayoutDerivedTotals } from './deriveLayoutTotals';
import { LayoutDerivedProvider } from './LayoutDerivedContext';
import type { LayoutNode } from './types';
import { RenderNodes } from './renderNodes';

export interface BespokeLayoutRendererProps extends BespokeFormSectionProps {
  layout: LayoutNode[];
}

export function BespokeLayoutRenderer({
  layout,
  ...props
}: BespokeLayoutRendererProps) {
  const schemaMap = useMemo(() => buildSchemaMap(props.schema), [props.schema]);

  // useMemo must come before any conditional return (Rules of Hooks).
  const derivedMap = useMemo(
    () =>
      Array.isArray(layout)
        ? computeLayoutDerivedTotals(layout, props.answers, {}, schemaMap)
        : {},
    [layout, props.answers, schemaMap]
  );

  if (!Array.isArray(layout)) {
    return (
      <div className='rounded border border-destructive p-4 text-sm text-destructive'>
        Layout error: layout_json must be a JSON array of nodes.
      </div>
    );
  }

  return (
    <BespokeSectionProvider {...props}>
      <LayoutDerivedProvider value={derivedMap}>
        <div className='space-y-4'>
          <RenderNodes
            nodes={layout}
            answers={props.answers}
            repeatBindings={{}}
          />
        </div>
      </LayoutDerivedProvider>
    </BespokeSectionProvider>
  );
}
